export const ModelList = {
  bar: {
    name: '酒吧场景',
    des: '一个精美的酒吧场景模型，展示了室内环境的细节',
  },
  garden: {
    name: '花园场景',
    des: '美丽的花园场景，包含各种植物和景观元素',
  },
  hero: {
    name: '英雄角色',
    des: '英雄角色模型，高质量的人物建模',
  },
  acg: {
    name: '日本场景',
    des: '日本场景，包含日本的风土人情',
  },
  acg1: {
    name: '日本场景ksplat',
    des: '日本场景，包含日本的风土人情',
  },
};
